// extracted by mini-css-extract-plugin
export default {"Promo__Section":"Promo_Promo__Section__LidRv","Promo__Box":"Promo_Promo__Box__A4Jsp","Promo__Title":"Promo_Promo__Title__tTovX"};